import React, { FC } from 'react';
import styled from 'styled-components';
import { TextFieldProps } from '@mui/material/TextField';
import Colours from '../../../design-system/colours';
import OvTextField from './OvTextField';

const OvSearchField: FC<TextFieldProps> = (props) => (
  <StyledOvTextField size="small" {...props} />
);

export default OvSearchField;

const StyledOvTextField = styled(OvTextField)`
  && {
    .MuiInputBase-formControl {
      background: ${Colours.WHITE};
      width: 100%;
      font-size: 0.875rem;
    }

    .MuiOutlinedInput-root {
      padding-top: 0;
      padding-bottom: 0;
      padding-left: 0;
    }

    .MuiOutlinedInput-root .MuiOutlinedInput-input {
      padding: 8px 10px;
    }
  }
`;
